<template>
  <div class="row justify-center items-center" style="padding: 10px; border: 1px solid #dcdcdc; border-radius: 6px; margin-top: 15px">
    <div class="col-5">
      <h5 style="color: var(--primary-color); margin-top: 6px">
        {{ name }}
      </h5>
    </div>
    <div class="col-5">
      <QBtn
        v-if="buttonCondition"
        color="primary"
        type="submit"
        no-caps
        style="float: right"
        @click="onClickSignButton"
        :loading="buttonLoading"
        >Sign</QBtn
      >
      <ProgressListItem
        v-if="listCondition1"
        text="completed"
        status="completed"
        style="float: right; margin-right: 15px"
      ></ProgressListItem>
      <ProgressListItem v-if="listCondition2" text="pending" status="pending" style="float: right; margin-right: 15px"></ProgressListItem>
    </div>
  </div>
</template>

<script>
import { QBtn } from 'quasar';
import ProgressListItem from '../../components/Atoms/ProgressListItem';

export default {
  name: 'DigitalSignAccount',
  components: { QBtn, ProgressListItem },
  props: {
    name: String,
    buttonCondition: Boolean,
    buttonLoading: Boolean,
    listCondition1: Boolean,
    listCondition2: Boolean
  },
  methods: {
    onClickSignButton: async function () {
      setTimeout(() => {
        this.$emit('onClickSignButton');
      });
    }
  }
};
</script>
